const _ = _ => {
    return [
        {
            name: `dashboard.${_}.alerts.index`,
            path: 'alerts',
            component: require('../views/dashboard/_/alerts/index').default
        },
        {
            name: `dashboard.${_}.applications.index`,
            path: 'applications',
            component: require('../views/dashboard/_/applications/index').default
        },
        {
            name: `dashboard.${_}.charges.show`,
            path: 'payments/ch:charge',
            component: require('../views/dashboard/_/charges/show').default
        },
        {
            name: `dashboard.${_}.documents.index`,
            path: 'documents',
            component: require('../views/dashboard/_/documents/index').default
        },
        {
            name: `dashboard.${_}.documents.show`,
            path: 'documents/:document',
            component: require('../views/dashboard/_/documents/show').default
        },
        {
            name: `dashboard.${_}.documents.files.index`,
            path: 'documents/:document/files',
            component: require('../views/dashboard/_/documents/files/index').default
        },
        {
            name: `dashboard.${_}.fees.index`,
            path: 'fees',
            component: require('../views/dashboard/_/fees/index').default
        },
        {
            name: `dashboard.${_}.fees.show`,
            path: 'fees/:fee',
            component: require('../views/dashboard/_/fees/show').default
        },
        {
            name: `dashboard.${_}.fees.charges.create`,
            path: 'fees/:fee/payments/new',
            component: require('../views/dashboard/_/fees/charges/create').default
        },
        {
            name: `dashboard.${_}.inventories.index`,
            path: 'inventories',
            component: require('../views/dashboard/_/inventories/index').default
        },
        {
            name: `dashboard.${_}.inventories.create`,
            path: 'inventories/new',
            component: require('../views/dashboard/_/inventories/create').default
        },
        {
            name: `dashboard.${_}.inventories.show`,
            path: 'inventories/:inventory',
            component: require('../views/dashboard/_/inventories/show').default
        },
        {
            name: `dashboard.${_}.inventories.files.index`,
            path: 'inventories/:inventory/files',
            component: require('../views/dashboard/_/inventories/files/index').default
        },
        {
            name: `dashboard.${_}.inventories.edit`,
            path: 'inventories/:inventory/edit',
            component: require('../views/dashboard/_/inventories/edit').default
        },
        {
            name: `dashboard.${_}.chats.index`,
            path: 'messages',
            component: require('../views/dashboard/_/chats/index').default
        },
        {
            name: `dashboard.${_}.chats.show`,
            path: 'messages/:chat',
            component: require('../views/dashboard/_/chats/show').default
        },
        {
            name: `dashboard.${_}.notifications.index`,
            path: 'notifications',
            component: require('../views/dashboard/_/notifications/index').default
        },
        {
            name: `dashboard.${_}.rents.index`,
            path: 'rents',
            component: require('../views/dashboard/_/rents/index').default
        },
        {
            name: `dashboard.${_}.rents.show`,
            path: 'rents/:rent',
            component: require('../views/dashboard/_/rents/show').default
        },
        {
            name: `dashboard.${_}.rents.charges.create`,
            path: 'rents/:rent/payments/new',
            component: require('../views/dashboard/_/rents/charges/create').default
        },
        {
            name: `dashboard.${_}.settings.index`,
            path: 'settings',
            component: require('../views/dashboard/_/settings/index').default
        },
        {
            name: `dashboard.${_}.settings.email.edit`,
            path: 'settings/email',
            component: require('../views/dashboard/_/settings/email/edit').default
        },
        {
            name: `dashboard.${_}.settings.password.edit`,
            path: 'settings/password',
            component: require('../views/dashboard/_/settings/password/edit').default
        },
        {
            name: `dashboard.${_}.settings.telephone.edit`,
            path: 'settings/telephone',
            component: require('../views/dashboard/_/settings/telephone/edit').default
        },
        {
            name: `dashboard.${_}.settings.notification-preferences.edit`,
            path: 'settings/notification-preferences',
            component: require('../views/dashboard/_/settings/notification-preferences/edit').default
        },
        {
            name: `dashboard.${_}.tasks.index`,
            path: 'tasks',
            component: require('../views/dashboard/_/tasks/index').default
        },
        {
            name: `dashboard.${_}.tasks.create`,
            path: 'tasks/new',
            component: require('../views/dashboard/_/tasks/create').default
        },
        {
            name: `dashboard.${_}.tasks.show`,
            path: 'tasks/:task',
            component: require('../views/dashboard/_/tasks/show').default
        },
        {
            name: `dashboard.${_}.tasks.edit`,
            path: 'tasks/:task/edit',
            component: require('../views/dashboard/_/tasks/edit').default
        },
        {
            name: `dashboard.${_}.tenancies.index`,
            path: 'tenancies',
            component: require('../views/dashboard/_/tenancies/index').default
        },
        {
            name: `dashboard.${_}.tenancies.show`,
            path: 'tenancies/:tenancy',
            component: require('../views/dashboard/_/tenancies/show').default
        },
        {
            name: `dashboard.${_}.tenancies.charges.create`,
            path: 'tenancies/:tenancy/payments/new',
            component: require('../views/dashboard/_/tenancies/charges/create').default
        }
    ]
}

export default [
    {
        path: '/dashboard/user',
        component: require('../components/the-layout-empty').default,
        children: [
            {
                path: '',
                component: require('../components/the-layout-card').default,
                props: route => {
                    return {
                        maxW: 'max-w-lg',
                        noBox: true
                    }
                },
                children: [
                    {
                        name: 'dashboard.users.bank-cards.create',
                        path: 'bank-cards/new',
                        component: require('../views/dashboard/users/bank-cards/create').default
                    },
                    {
                        name: 'dashboard.users.payment-intents.show',
                        path: 'payments/pi:payment_intent',
                        component: require('../views/dashboard/users/payment-intents/show').default
                    },
                    {
                        name: 'dashboard.users.subscriptions.index',
                        path: 'subscriptions',
                        component: require('../views/dashboard/users/subscriptions/index').default
                    },
                    {
                        name: 'dashboard.users.subscriptions.create',
                        path: 'subscriptions/new',
                        component: require('../views/dashboard/users/subscriptions/create').default
                    }
                ]
            }
        ]
    },
    {
        path: '/dashboard/landlords/:landlord',
        component: require('../components/the-layout-empty').default,
        children: [
            {
                path: '',
                component: require('../components/the-layout-dashboard').default,
                children: [
                    {
                        name: 'dashboard.landlords.applications.show',
                        path: 'applications/:application',
                        component: require('../views/dashboard/landlords/applications/show').default
                    },
                    {
                        name: 'dashboard.landlords.applications.applicants.index',
                        path: 'applications/:application/applicants',
                        redirect: {
                            name: 'dashboard.landlords.applications.show'
                        }
                    },
                    {
                        name: 'dashboard.landlords.applications.applicants.show',
                        path: 'applications/:application/applicants/:applicant',
                        component: require('../views/dashboard/landlords/applications/applicants/show').default
                    },
                    {
                        name: 'dashboard.landlords.bank-accounts.index',
                        path: 'bank-accounts',
                        component: require('../views/dashboard/landlords/bank-accounts/index').default
                    },
                    {
                        name: 'dashboard.landlords.bank-accounts.show',
                        path: 'bank-accounts/:bank',
                        component: require('../views/dashboard/landlords/bank-accounts/show').default
                    },
                    {
                        name: 'dashboard.landlords.bank-accounts.create',
                        path: 'bank-accounts/new',
                        component: require('../views/dashboard/landlords/bank-accounts/create').default
                    },
                    {
                        name: 'dashboard.landlords.contacts.index',
                        path: 'contacts',
                        component: require('../views/dashboard/landlords/contacts/index').default
                    },
                    {
                        name: 'dashboard.landlords.contacts.create',
                        path: 'contacts/new',
                        component: require('../views/dashboard/landlords/contacts/create').default
                    },
                    {
                        name: 'dashboard.landlords.contacts.show',
                        path: 'contacts/:contact',
                        component: require('../views/dashboard/landlords/contacts/show').default
                    },
                    {
                        name: 'dashboard.landlords.contacts.edit',
                        path: 'contacts/:contact/edit',
                        component: require('../views/dashboard/landlords/contacts/edit').default
                    },
                    {
                        name: 'dashboard.landlords.documents.create',
                        path: 'documents/new',
                        component: require('../views/dashboard/landlords/documents/create').default
                    },
                    {
                        name: 'dashboard.landlords.fees.create',
                        path: 'fees/new',
                        component: require('../views/dashboard/landlords/fees/create').default
                    },
                    {
                        name: 'dashboard.landlords.job-sheets.create',
                        path: 'job-sheets/new',
                        component: require('../views/dashboard/landlords/job-sheets/create').default
                    },
                    {
                        name: 'dashboard.landlords.job-sheets.show',
                        path: 'job-sheets/:job_sheet',
                        component: require('../views/dashboard/landlords/job-sheets/show').default
                    },
                    {
                        name: 'dashboard.landlords.job-sheets.comments.create',
                        path: 'job-sheets/:job_sheet/comments/new',
                        component: require('../views/dashboard/landlords/job-sheets/comments/create').default
                    },
                    {
                        name: 'dashboard.landlords.listings.create',
                        path: 'listings/new',
                        component: require('../views/dashboard/landlords/listings/create').default
                    },
                    {
                        name: 'dashboard.landlords.listings.index',
                        path: 'listings',
                        component: require('../views/dashboard/landlords/listings/index').default
                    },
                    {
                        name: 'dashboard.landlords.listings.show',
                        path: 'listings/:listing',
                        component: require('../views/dashboard/landlords/listings/show').default
                    },
                    {
                        name: 'dashboard.landlords.listings.edit',
                        path: 'listings/:listing/edit',
                        component: require('../views/dashboard/landlords/listings/edit').default
                    },
                    {
                        name: 'dashboard.landlords.maintenances.index',
                        path: 'maintenances',
                        component: require('../views/dashboard/landlords/maintenances/index').default
                    },
                    {
                        name: 'dashboard.landlords.maintenances.create',
                        path: 'maintenances/new',
                        component: require('../views/dashboard/landlords/maintenances/create').default
                    },
                    {
                        name: 'dashboard.landlords.maintenances.show',
                        path: 'maintenances/:maintenance',
                        component: require('../views/dashboard/landlords/maintenances/show').default
                    },
                    {
                        name: 'dashboard.landlords.maintenances.edit',
                        path: 'maintenances/:maintenance/edit',
                        component: require('../views/dashboard/landlords/maintenances/edit').default
                    },
                    {
                        name: 'dashboard.landlords.overview.index',
                        path: 'overview',
                        component: require('../views/dashboard/landlords/overview/index').default
                    },
                    {
                        name: 'dashboard.landlords.payments.show',
                        path: 'payments/py:payment',
                        component: require('../views/dashboard/landlords/payments/show').default
                    },
                    {
                        name: 'dashboard.landlords.payouts.show',
                        path: 'payments/po:payout',
                        component: require('../views/dashboard/landlords/payouts/show').default
                    },
                    {
                        name: 'dashboard.landlords.properties.index',
                        path: 'properties',
                        component: require('../views/dashboard/landlords/properties/index').default
                    },
                    {
                        name: 'dashboard.landlords.properties.create',
                        path: 'properties/new',
                        component: require('../views/dashboard/landlords/properties/create').default
                    },
                    {
                        name: 'dashboard.landlords.properties.show',
                        path: 'properties/:property',
                        component: require('../views/dashboard/landlords/properties/show').default
                    },
                    {
                        name: 'dashboard.landlords.properties.edit',
                        path: 'properties/:property/edit',
                        component: require('../views/dashboard/landlords/properties/edit').default
                    },
                    {
                        name: 'dashboard.landlords.residencies.create',
                        path: 'residencies/new',
                        component: require('../views/dashboard/landlords/residencies/create').default
                    },
                    {
                        name: 'dashboard.landlords.tenants.index',
                        path: 'tenants',
                        component: require('../views/dashboard/landlords/occupants/index').default
                    },
                    {
                        name: 'dashboard.landlords.occupants.create',
                        path: 'tenants/new',
                        component: require('../views/dashboard/landlords/occupants/create').default
                    },
                    {
                        name: 'dashboard.landlords.occupants.show',
                        path: 'tenants/:occupant',
                        component: require('../views/dashboard/landlords/occupants/show').default
                    },
                    {
                        name: 'dashboard.landlords.occupants.edit',
                        path: 'tenants/:occupant/edit',
                        component: require('../views/dashboard/landlords/occupants/edit').default
                    },
                    {
                        name: 'dashboard.landlords.tenancies.create',
                        path: 'tenancies/new',
                        component: require('../views/dashboard/landlords/tenancies/create').default
                    },
                    {
                        name: 'dashboard.landlords.transactions.index',
                        path: 'payments',
                        component: require('../views/dashboard/landlords/transactions/index').default
                    },
                    {
                        name: 'dashboard.landlords.settings.account.edit',
                        path: 'settings/account',
                        component: require('../views/dashboard/landlords/settings/account/edit').default
                    },
                    {
                        path: 'verification',
                        component: require('../views/dashboard/landlords/verification/layout').default,
                        children: [
                            {
                                path: '',
                                name: 'dashboard.landlords.verification.edit',
                                redirect: {
                                    name: 'dashboard.landlords.verification.intro.edit'
                                }
                            },
                            {
                                name: 'dashboard.landlords.verification.intro.edit',
                                path: 'intro',
                                component: require('../views/dashboard/landlords/verification/intro/edit').default
                            },

                            {
                                name: 'dashboard.landlords.verification.account.edit',
                                path: 'account',
                                component: require('../views/dashboard/landlords/verification/account/edit').default
                            },
                            {
                                name: 'dashboard.landlords.verification.business.edit',
                                path: 'business',
                                component: require('../views/dashboard/landlords/verification/business/edit').default
                            },
                            {
                                name: 'dashboard.landlords.verification.bank.edit',
                                path: 'bank',
                                component: require('../views/dashboard/landlords/verification/bank/edit').default
                            },
                            {
                                name: 'dashboard.landlords.verification.confirm.edit',
                                path: 'confirm',
                                component: require('../views/dashboard/landlords/verification/confirm/edit').default
                            }
                        ]
                    },
                    ..._('landlords')
                ]
            }
        ]
    },
    {
        path: '/dashboard/tenants/:tenant',
        component: require('../components/the-layout-dashboard').default,
        children: [
            {
                name: 'dashboard.tenants.applications.show',
                path: 'applications/:application',
                component: require('../views/dashboard/tenants/applications/show').default
            },
            {
                name: 'dashboard.tenants.bank-cards.index',
                path: 'bank-cards',
                component: require('../views/dashboard/tenants/bank-cards/index').default
            },
            {
                name: 'dashboard.tenants.bank-cards.create',
                path: 'bank-cards/new',
                component: require('../views/dashboard/tenants/bank-cards/create').default
            },
            {
                name: 'dashboard.tenants.bank-cards.show',
                path: 'bank-cards/:card',
                component: require('../views/dashboard/tenants/bank-cards/show').default
            },
            {
                name: 'dashboard.tenants.bank-cards.confirm.edit',
                path: 'bank-cards/:card/confirm',
                component: require('../views/dashboard/tenants/bank-cards/confirm/edit').default
            },
            {
                name: 'dashboard.tenants.tenancies.auto-payments.create',
                path: 'tenancies/:tenancy/smart-payments/new',
                component: require('../views/dashboard/tenants/tenancies/auto-payments/create').default
            },
            {
                name: 'dashboard.tenants.charges.index',
                path: 'payments',
                component: require('../views/dashboard/tenants/charges/index').default
            },
            {
                name: 'dashboard.tenants.charges.confirm',
                path: 'payments/ch:charge/confirm',
                component: require('../views/dashboard/tenants/charges/confirm/invoke').default
            },
            {
                name: 'dashboard.tenants.settings.account.edit',
                path: 'settings/account',
                component: require('../views/dashboard/tenants/settings/account/edit').default
            },
            {
                name: 'dashboard.tenants.overview.index',
                path: 'overview',
                component: require('../views/dashboard/tenants/overview/index').default
            },
            ..._('tenants')
        ]
    }
]
